import { render } from "./logo_verse.vue?vue&type=template&id=3e77688c&scoped=true"
import script from "./logo_verse.vue?vue&type=script&lang=js"
export * from "./logo_verse.vue?vue&type=script&lang=js"

import "./logo_verse.vue?vue&type=style&index=0&id=3e77688c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e77688c"]])

export default __exports__